import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() elevation: 'sm' | 'md' | 'lg' = 'md';
  @Input() padding: 'sm' | 'md' | 'lg' = 'md';
  @Input() rounded: boolean = true;
}
